import cloneDeep from 'lodash/cloneDeep'

export type ObjectArrayType = {
  [key: string]: Array<number>,
}

const getList = (id: string, groupedIds: ObjectArrayType): number[] => groupedIds[id] || []

type Payload = {
  sourceDroppableId: string,
  destinationDroppableId: string,
}

function modifyGroupedIdsSort(
  fromIndex: number,
  toIndex: number,
  payload: Payload,
  groupedIds: ObjectArrayType,
): ObjectArrayType {
  const { destinationDroppableId, sourceDroppableId } = payload

  const updatedGroupedIds: ObjectArrayType = cloneDeep(groupedIds)

  if (destinationDroppableId === sourceDroppableId){
    const list = getList(destinationDroppableId, updatedGroupedIds)
    const [removedItemId] = list.splice(fromIndex, 1)
    if (removedItemId === undefined) return groupedIds

    list.splice(toIndex, 0, removedItemId)
    updatedGroupedIds[destinationDroppableId] = list

    return updatedGroupedIds
  }

  const fromList = getList(sourceDroppableId, updatedGroupedIds)
  const toList = getList(destinationDroppableId, updatedGroupedIds)
  const [removedItemId] = fromList.splice(fromIndex, 1)
  if (removedItemId === undefined) return groupedIds

  toList.splice(toIndex, 0, removedItemId)
  updatedGroupedIds[destinationDroppableId] = toList
  updatedGroupedIds[sourceDroppableId] = fromList

  return updatedGroupedIds
}

export default modifyGroupedIdsSort
